import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { fetchInternalDoctor } from "services/doctor";

const InternalDoctorDropdown = ({
  employee_id,
  setFilterValue,
  doctorId,
  setdoctorId,
  isRequired,
  status,
}) => {
  const key = "Internal Doctor";
  const [selectedDoctorId, setSelectedDoctorId] = useState("");

  const { data, isLoading, error } = useQuery(
    ["internal-doctor-dropdown", employee_id],
    () => fetchInternalDoctor({ employee_id }),
    {
      keepPreviousData: false,
      staleTime: DROPDOWN_STALE_TIME,
    },
  );

  useEffect(() => {
    if (doctorId) {
      setSelectedDoctorId(doctorId);
    }
  }, [doctorId]);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error Loading Internal Type</div>;

  const doctorsData = data?.data?.data;
  let doctorsArray = [];

  if (doctorsData) {
    if (Array.isArray(doctorsData)) {
      doctorsArray = doctorsData;
    } else {
      doctorsArray = Object.values(doctorsData);
    }
  }

  const options = doctorsArray.map((item) => ({
    value: item?.id || item?.doctor_obj?.id,
    label: item?.doctor_name || item?.doctor_obj?.doctor_name,
  }));

  const getClassName = () => {
    if (isRequired && (!doctorId || doctorId === "")) {
      return "react-select-container is-invalid";
    }
    return "react-select-container";
  };

  const isInvalid =
    isRequired && (selectedDoctorId == null || selectedDoctorId === "");

  return (
    <>
      <Select
        options={options}
        isClearable
        placeholder={`Select ${key}`}
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          control: (base, state) => ({
            ...base,
            borderColor: isInvalid ? "#dc3545" : base.borderColor,
            boxShadow:
              isInvalid && state.isFocused
                ? "0 0 0 0.2rem rgba(220, 53, 69, 0.25)"
                : base.boxShadow,
            "&:hover": {
              borderColor: isInvalid ? "#dc3545" : base["&:hover"].borderColor,
            },
          }),
        }}
        value={options.find((option) => option.value === doctorId)}
        onChange={(selectedOption) => {
          const value = selectedOption ? selectedOption.value : "";
          setFilterValue(value);
          setdoctorId(value);
          setSelectedDoctorId(value);
        }}
        className={getClassName()}
      />
      {isInvalid && (
        <div style={{ color: "#dc3545", fontSize: "12px", marginTop: "5px" }}>
          This field is required
        </div>
      )}
    </>
  );
};

export default InternalDoctorDropdown;
